// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bjGx","title":"styles_title__3DkjZ"};